import CheckBox from 'material-ui/Checkbox';
import {getDisplayableShortGrade} from '../services';
import React, {PropTypes} from 'react';

const bindHandler = (handler, filterParentName, id) => handler.bind(null, filterParentName, id);

const getCharacterList = (filters, handleCheck) => filters.characters.map(opt =>
  <div className="filter-menu-checkbox-container" key={opt.id}>
    <CheckBox checked={opt.value} onCheck={bindHandler(handleCheck, 'characters', opt.id)} id={opt.id} label={opt.name} />
    <div className="filter-menu-subtext"><i>{opt.foundation}</i></div>
  </div>
);

const getGradeList = (filters, handleCheck) => filters.grades.map(opt =>
  <div key={opt.id}>
    <CheckBox checked={opt.value} onCheck={bindHandler(handleCheck, 'grades', opt.id)} id={opt.id} label={getDisplayableShortGrade(opt)} />
  </div>
);

const getLessonTypeList = (filters, handleCheck) => filters.lessonTypes.map(opt =>
  <div key={opt.id}>
    <CheckBox checked={opt.value} onCheck={bindHandler(handleCheck, 'lessonTypes', opt.id)} id={opt.id} label={opt.name} />
  </div>
);

const getSubjectList = (filters, handleCheck) => filters.subjects.map(opt =>
  <div key={opt.id}>
    <CheckBox checked={opt.value} onCheck={bindHandler(handleCheck, 'subjects', opt.id)} id={opt.id} label={opt.name} />
  </div>
);

const getOtherList = (filters, handleCheck) => filters.other.map(opt =>
  <div key={opt.id}>
    <CheckBox checked={opt.value} onCheck={bindHandler(handleCheck, 'other', opt.id)} id={opt.id} label={opt.text} />
  </div>
);

const getFilterColumn = (filters, handleCheck, filterName, listDisplaySource, subHeading) => {
  if (!filters[filterName]) return null;
  return (
    <div className="filter-menu-column">
      <div className="filter-menu-subheading">{subHeading}</div>
      {listDisplaySource(filters, handleCheck)}
    </div>
  );
};

export default function FilterMenu({filters, handleCheck}) {
  return (
    <div className="material-filter-menu">
      <div className="filter-menu-heading">FILTER</div>
      { getFilterColumn(filters, handleCheck, 'characters', getCharacterList, 'Foundation') }
      { getFilterColumn(filters, handleCheck, 'grades', getGradeList, 'Grade') }
      { getFilterColumn(filters, handleCheck, 'other', getOtherList, 'Other') }
      { getFilterColumn(filters, handleCheck, 'lessonTypes', getLessonTypeList, 'Lesson Types') }
      { getFilterColumn(filters, handleCheck, 'subjects', getSubjectList, 'Subject Area') }
    </div>
  );
}

FilterMenu.propTypes = {
  filters: PropTypes.object.isRequired,
  handleCheck: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/features/shared/components/FilterMenu.js